import React from 'react';
import Navbar from '../globals/Navbar';
import Theme from '../globals/Theme';
import Team from './Team';
import Objective from './Objective';
import Project from './Project';
import Model from './Model';
import Conclusion from './Conclusion';
import Contacts from './Contacts';
import lightBackground from '../../resources/light_background.png';
import darkBackground from '../../resources/dark_background.png';

const Page = () => {
  return (
    <div id='page' className='page'>
        <div className='backgroundDiv'>
          <img id='lightBackgroundImg' className='backgroundImg' src={lightBackground}></img>
          <img id='darkBackgroundImg' className='backgroundImg' src={darkBackground}></img>
        </div>
        <Navbar />
        <Theme />
        <Team />
        <Objective />
        <Project />
        <Model />
        <Conclusion />
        <Contacts />
    </div>
  )
}

export default Page;